import * as common from './common.json';

export const id = {
  common,
};
